<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
  import {wpsr_getYwgz_api} from "@/api/wpsr";
export default {
  name: '',
  components: {
  },
  props:{
	  ywdiag:{
		  type:Boolean,
		  default:false
	  },
  },
  data: function() {
    return {
		headData: getdata().headData,
		tableData: getdata().tableData,
    };
  },
  created() {
    this.init();
  },
  methods: {
	  spanmethod({
	  	row,
	  	column,
	  	rowIndex,
	  	columnIndex 
	  }) {
	  	if (columnIndex === 0) {
	  		if (rowIndex === 0) {
	  			return {
	  				rowspan: 7,
	  				colspan: 1
	  			};
	  		} else if (rowIndex === 7) {
	  			return {
	  				rowspan: 11,
	  				colspan: 1
	  			};
	  		} else if (rowIndex === 18) {
	  			return {
	  				rowspan: 2,
	  				colspan: 1
	  			};
	  		} else if (rowIndex === 20) {
	  			return {
	  				rowspan: 2,
	  				colspan: 1
	  			};
	  		} else {
	  			return {
	  				rowspan: 0,
	  				colspan: 0
	  			};
	  		}
	  	}
	  	if (columnIndex === 1) {
	  		if (rowIndex === 0) {
	  			return {
	  				rowspan: 5,
	  				colspan: 1
	  			};
	  		} else if (rowIndex === 5) {
	  			return {
	  				rowspan: 2,
	  				colspan: 1
	  			};
	  		}else if(rowIndex === 7){
	  			return {
	  				rowspan: 9,
	  				colspan: 1
	  			};
	  		}else if(rowIndex === 16){
	  			return {
	  				rowspan: 2,
	  				colspan: 1
	  			};
	  		}else if([18,19,20,21].includes(rowIndex)){
	  			return {
	  				rowspan: 1,
	  				colspan: 2
	  			};
	  		}
	  		else {
	  			return {
	  				rowspan: 0,
	  				colspan: 0
	  			};
	  		}
	  	}
	  	if (columnIndex === 2) {
	  		if([18,19,20,21].includes(rowIndex)){
	  			return {
	  				rowspan: 0,
	  				colspan: 0
	  			};
	  		}
	  	}
	  },
	  closediag(){
		  this.$emit("closediag",false)
	  },
	  headercellstyle({
	  	row,
	  	column,
	  	rowIndex,
	  	columnIndex
	  }) {
	  	if (rowIndex === 0) {
	  		if (columnIndex === 0) {
	  			this.$nextTick(() => {
	  				if (document.getElementsByClassName(column.id).length !== 0) {
	  					document
	  						.getElementsByClassName(column.id)[0]
	  						.setAttribute('colSpan', 4);
	  				}
	  			});
				return 'background:white!important'
	  		}
	  		if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
	  			return {
	  				display: "none",
	  			};
	  		}
			if (columnIndex === 4 || columnIndex === 5 || columnIndex === 6) {
				return 'background:white!important'
			}
	  	}
	  	if (rowIndex === 1) {
	  		if (columnIndex ===11) {
	  				return {
	  					display: "none",
	  				};
	  		}
	  	}
		
	  },
    //初始化数据
    init(){
        this.getYwgzData();
    },
    //获取业务科目数据
    getYwgzData(){
      wpsr_getYwgz_api({}).then(res=>{
        if (res.data.code == 1 ){
          this.appendData(res.data.data.yegzlist);
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //拼接业务科目数据
    appendData(data){
      let result = {};
      data.map(r => {
        result[r.hangh] = r;
      })
      this.tableData.forEach((v , i )=>{
        let obj = result[v.grade];
        v.xse = obj.xiaose;
        v.ynse = obj.yingnse;
      });
    }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
